import {
	SCRIPT_ALLOCATION_ERROR,
	SCRIPT_ALLOCATION_COUNT,
	SCRIPT_ALLOCATION_GET,
	SCRIPT_ALLOCATION_GET_ALL,
	SCRIPT_ALLOCATION_CLEAR_ALL_UPDATES
} from '../Enums/Script.Allocation.Enums';

const initState = {
	data: [],
	all_data: [],
	errors: [],
	updated: [],
	hasUpdates: false,
	count: { total: 0, complete: 0 },
	isLoaded: false
};

const allocation = (state = initState, action) => {
	let updatedState = {};
	const { type, payload } = action;
	switch (type) {
		case SCRIPT_ALLOCATION_COUNT:
			updatedState = {
				...state,
				count: payload.data,
				errors: payload.errors,
				isLoaded: true
			};
			break;
		case SCRIPT_ALLOCATION_ERROR:
			updatedState = { ...state, errors: payload.errors, isLoaded: true };
			break;
		case SCRIPT_ALLOCATION_GET:
			updatedState = {
				...state,
				data: payload.data,
				errors: payload.errors
			};
			break;
		case SCRIPT_ALLOCATION_GET_ALL:
			updatedState = {
				...state,
				all_data: payload.data,
				errors: payload.errors
			};
			break;
		case SCRIPT_ALLOCATION_CLEAR_ALL_UPDATES:
			updatedState = { ...state, updated: [], hasUpdates: false };
			break;
		default:
			return state;
	}
	return updatedState;
};

export default allocation;
